var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-overlay',{attrs:{"className":"loading-common","show":_vm.show,"zIndex":_vm.zIndex}},[_c('div',{staticClass:"wrapper"},[_c('van-loading',{attrs:{"color":"#4281ef"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }